import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { UserCheck } from 'lucide-react';
import { Vazio } from '../../componentes/estados';
import { Selecao } from '../../componentes/formulario';
import { Tabela } from '../../componentes/tabela';
import { CHAVE, useCardAberto, useQuadros, useRotuloQuadro, useTempoRealTarefas } from './comum';
import { DrawerCard } from './DrawerCard';
import { useColunasCards } from './Lista';
import type { Card } from './tipos';

/** Aba Minhas tarefas: os cards abertos em que eu sou o responsável, dos mais urgentes para os menos, por quadro. */
export function Minhas() {
  const { t } = useTranslation('tarefas');
  useTempoRealTarefas();
  const rotuloQuadro = useRotuloQuadro();
  const quadros = useQuadros();
  const [cardAberto, abrir] = useCardAberto();
  const [quadro, setQuadro] = useState('');
  const colunas = useColunasCards().filter((c) => c.chave !== 'responsavel_nome');
  return (
    <>
      <Tabela<Card>
        tela="tarefas.minhas"
        caminho="/tarefas/cards"
        chaveConsulta={[...CHAVE, 'minhas']}
        params={{ minhas: 'true', estado: 'abertos', ordem: 'prioridade', quadro_id: quadro || undefined }}
        filtros={{ quadro }}
        aoAplicarFiltros={(f) => setQuadro(typeof f.quadro === 'string' ? f.quadro : '')}
        colunas={colunas}
        aoClicar={(c) => abrir(c.id)}
        vazio={<Vazio icone={<UserCheck className="size-5" aria-hidden />} titulo={t('minhas.vazioTitulo')} texto={t('minhas.vazioTexto')} />}
        filtrosExtra={
          <div className="w-full sm:w-52">
            <Selecao aria-label={t('campos.quadro')} opcoes={(quadros.data?.itens ?? []).map((q) => ({ valor: q.id, rotulo: rotuloQuadro(q) }))} vazio={`${t('campos.quadro')}: ${t('kanban.todos')}`} value={quadro} onChange={(e) => setQuadro(e.target.value)} />
          </div>
        }
      />
      {cardAberto && <DrawerCard key={cardAberto} id={cardAberto} colunas={(quadros.data?.itens ?? []).flatMap((q) => q.colunas)} aoFechar={() => abrir(null)} />}
    </>
  );
}
